import React from "react";
import { Modal } from "antd";
import EnhancedFlightTimes from "./EnhancedFlightTimes";

/**
 * 增强航班时间模态框组件
 * 用于在模态框中显示EnhancedFlightTimes的popover内容
 */
const EnhancedFlightTimesModal = ({ visible, onClose, flight, airportsMap = {}, allFlights = [], onFlightInfoEditSuccess }) => {
    if (!flight) return null;

    return (
        <Modal open={visible} onCancel={onClose} footer={null} centered destroyOnHidden>
            <EnhancedFlightTimes flight={flight} airportsMap={airportsMap} allFlights={allFlights} onFlightInfoEditSuccess={onFlightInfoEditSuccess} showAsModal={true} />
        </Modal>
    );
};

export default EnhancedFlightTimesModal;
